import React from 'react';

const ListTextBlock = ({listArray}) => (
  <ul className="list-dotpoints">
    {listArray.map(item => (
      <li className="text-soft">{item}</li>
    ))}
  </ul>
);

export default ListTextBlock;



// WEBPACK FOOTER //
// ./src/layout/ListTextBlock.js